// src/pages/client/Documentation.jsx
import React from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';

const Documentation = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />
      
      {/* Hero Section */}
      <div className="pt-20 pb-16 bg-gradient-to-br from-slate-800 via-slate-700 to-slate-600">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Documentation
          </h1>
          <p className="text-xl text-slate-300 mb-8 max-w-3xl mx-auto">
            Guide complet d'utilisation de Jobrise pour maximiser votre efficacité en recrutement
          </p>
          <div className="flex justify-center space-x-4">
            <button className="bg-white text-slate-800 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition">
              Commencer
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-slate-800 transition">
              Rechercher
            </button>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <input 
                type="text" 
                placeholder="Rechercher dans la documentation..." 
                className="w-full p-4 pl-12 border border-slate-300 rounded-lg text-lg focus:ring-2 focus:ring-slate-500 focus:border-transparent"
              />
              <svg className="absolute left-4 top-4 w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Documentation Sections */}
      <div className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {/* Getting Started */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-4">Guide de Démarrage</h3>
              <p className="text-slate-600 mb-4">
                Découvrez les bases de Jobrise et configurez votre compte en quelques minutes.
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Configuration initiale
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Premier import de candidats
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Navigation dans l'interface
                </li>
              </ul>
            </div>

            {/* CVtheque */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-4">Gestion CVthèque</h3>
              <p className="text-slate-600 mb-4">
                Apprenez à gérer efficacement votre base de candidats et à optimiser vos recherches.
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Import et export de données
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Système de tags
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Recherche et filtrage
                </li>
              </ul>
            </div>

            {/* Process Management */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-4">Processus de Recrutement</h3>
              <p className="text-slate-600 mb-4">
                Maîtrisez le workflow de recrutement et le suivi des candidatures.
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Création de processus
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Suivi des étapes
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-slate-400 rounded-full mr-2"></span>
                  Collaboration équipe
                </li>
              </ul>
            </div>
          </div>

          {/* Quick Links */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-16">
            <h3 className="text-2xl font-bold text-center mb-8">Liens Rapides</h3>
            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center p-4 rounded-lg hover:bg-gray-50 transition">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h4 className="font-semibold text-sm">Démarrage Rapide</h4>
                <p className="text-xs text-slate-600">5 min pour commencer</p>
              </div>

              <div className="text-center p-4 rounded-lg hover:bg-gray-50 transition">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                  </svg>
                </div>
                <h4 className="font-semibold text-sm">API & Intégrations</h4>
                <p className="text-xs text-slate-600">Connectez vos outils</p>
              </div>

              <div className="text-center p-4 rounded-lg hover:bg-gray-50 transition">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h4 className="font-semibold text-sm">Bonnes Pratiques</h4>
                <p className="text-xs text-slate-600">Optimisez votre usage</p>
              </div>

              <div className="text-center p-4 rounded-lg hover:bg-gray-50 transition">
                <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.863-.833-2.633 0L4.184 17.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <h4 className="font-semibold text-sm">Résolution Problèmes</h4>
                <p className="text-xs text-slate-600">FAQ et dépannage</p>
              </div>
            </div>
          </div>

          {/* Documentation Screenshot */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-center mb-8">Interface de Documentation</h3>
            <div className="bg-gray-100 rounded-lg p-8">
              <p className="text-slate-500 text-center text-lg mb-4">
                [Screenshot de la documentation détaillée avec navigation et exemples]
              </p>
              <div className="h-96 bg-gradient-to-br from-slate-100 to-slate-200 rounded-lg flex items-center justify-center">
                <span className="text-slate-600">Documentation Interactive avec Exemples</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Documentation;